// ISO 3166-1 alpha-2 country list for the captain registration dropdown.
// Order: alphabetical by display name. Codes follow ISO 3166-1 alpha-2 so
// FlagCDN can serve the matching flag image.
export const COUNTRIES = [
  { code: "DZ", name: "Algeria" },
  { code: "AR", name: "Argentina" },
  { code: "AM", name: "Armenia" },
  { code: "AU", name: "Australia" },
  { code: "AT", name: "Austria" },
  { code: "BD", name: "Bangladesh" },
  { code: "BY", name: "Belarus" },
  { code: "BE", name: "Belgium" },
  { code: "BO", name: "Bolivia" },
  { code: "BR", name: "Brazil" },
  { code: "BG", name: "Bulgaria" },
  { code: "BF", name: "Burkina Faso" },
  { code: "CM", name: "Cameroon" },
  { code: "CA", name: "Canada" },
  { code: "CL", name: "Chile" },
  { code: "CN", name: "China" },
  { code: "CO", name: "Colombia" },
  { code: "CZ", name: "Czech Republic" },
  { code: "DK", name: "Denmark" },
  { code: "EC", name: "Ecuador" },
  { code: "EG", name: "Egypt" },
  { code: "SV", name: "El Salvador" },
  { code: "EE", name: "Estonia" },
  { code: "FI", name: "Finland" },
  { code: "FR", name: "France" },
  { code: "DE", name: "Germany" },
  { code: "GB", name: "Great Britain" },
  { code: "GR", name: "Greece" },
  { code: "GT", name: "Guatemala" },
  { code: "HK", name: "Hong Kong" },
  { code: "IN", name: "India" },
  { code: "IR", name: "Iran" },
  { code: "IL", name: "Israel" },
  { code: "IT", name: "Italy" },
  { code: "CI", name: "Ivory Coast" },
  { code: "JP", name: "Japan" },
  { code: "KZ", name: "Kazakhstan" },
  { code: "KR", name: "Korea" },
  { code: "KG", name: "Kyrgyzstan" },
  { code: "LT", name: "Lithuania" },
  { code: "MY", name: "Malaysia" },
  { code: "MX", name: "Mexico" },
  { code: "MN", name: "Mongolia" },
  { code: "NP", name: "Nepal" },
  { code: "NL", name: "Netherlands" },
  { code: "NO", name: "Norway" },
  { code: "PK", name: "Pakistan" },
  { code: "PE", name: "Peru" },
  { code: "PH", name: "Philippines" },
  { code: "PL", name: "Poland" },
  { code: "RU", name: "Russia" },
  { code: "RS", name: "Serbia" },
  { code: "SG", name: "Singapore" },
  { code: "ZA", name: "South Africa" },
  { code: "ES", name: "Spain" },
  { code: "LK", name: "Sri Lanka" },
  { code: "SE", name: "Sweden" },
  { code: "CH", name: "Switzerland" },
  { code: "TW", name: "Taiwan, China" },
  { code: "TH", name: "Thailand" },
  { code: "TN", name: "Tunisia" },
  { code: "TR", name: "Türkiye" },
  { code: "UG", name: "Uganda" },
  { code: "UA", name: "Ukraine" },
  { code: "US", name: "United States" },
  { code: "UY", name: "Uruguay" },
  { code: "UZ", name: "Uzbekistan" },
  { code: "VN", name: "Vietnam" },
];

export function countryFlagUrl(code) {
  if (!code) return "";
  // flagcdn supplies SVG flags
  return `https://flagcdn.com/${alpha2(code).toLowerCase()}.svg`;
}

export function countryName(code) {
  const found = COUNTRIES.find((c) => c.code === alpha2(code));
  return found ? found.name : code;
}

// Tournament pairing/standings files use 3-letter federation codes (CHN, MNG,
// GBR...), while flagcdn and our COUNTRIES list use ISO 3166-1 alpha-2 (CN,
// MN, GB...). Map 3→2 here; unknown codes fall through unchanged so flagcdn
// just returns a blank/broken image rather than throwing.
const ALPHA3_TO_ALPHA2 = {
  ARG: "AR", ARM: "AM", AUS: "AU", AUT: "AT", BGD: "BD", BLR: "BY", BEL: "BE",
  BOL: "BO", BRA: "BR", BGR: "BG", BFA: "BF", CMR: "CM", CAN: "CA", CHL: "CL",
  CHN: "CN", COL: "CO", CZE: "CZ", DNK: "DK", DZA: "DZ", ECU: "EC", EGY: "EG",
  SLV: "SV", EST: "EE", FIN: "FI", FRA: "FR", DEU: "DE", GBR: "GB", GRC: "GR",
  GTM: "GT", HKG: "HK", IND: "IN", IRN: "IR", ISR: "IL", ITA: "IT", CIV: "CI",
  JPN: "JP", KAZ: "KZ", KOR: "KR", KGZ: "KG", LTU: "LT", MYS: "MY", MEX: "MX",
  MNG: "MN", NPL: "NP", NLD: "NL", NOR: "NO", PAK: "PK", PER: "PE", PHL: "PH",
  POL: "PL", RUS: "RU", SRB: "RS", SGP: "SG", ZAF: "ZA", ESP: "ES", LKA: "LK",
  SWE: "SE", CHE: "CH", TWN: "TW", TPE: "TW", THA: "TH", TUN: "TN", TUR: "TR",
  UGA: "UG", UKR: "UA", USA: "US", URY: "UY", UZB: "UZ", VNM: "VN",
};

export function alpha2(code) {
  if (!code) return "";
  const upper = String(code).toUpperCase();
  if (upper.length === 2) return upper;
  return ALPHA3_TO_ALPHA2[upper] || upper;
}
